// extracted by mini-css-extract-plugin
export default {"root":"AdminReportingPage_root__uVEzs"};